
import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { ReferralTab } from '@/components/sesh/ReferralTab';
import { SeshBalance } from '@/components/sesh/SeshBalance';
import PageSEO from '@/components/seo/PageSEO';

const Referrals = () => {
  // Define breadcrumbs for better SEO
  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Indicações",
      item: "https://metrocalma.org/indicacoes"
    }
  ];
  
  return (
    <MainLayout>
      <PageSEO
        title="Programa de Indicações | metrocalma"
        description="Indique amigos para a metrocalma e ganhe benefícios. Nosso programa de indicação recompensa você por compartilhar a plataforma com pessoas que podem se beneficiar de nossos serviços."
        canonicalUrl="https://metrocalma.org/indicacoes"
        ogType="website"
        keywords="programa de indicação, indique e ganhe, referral program, metrocalma, saúde mental"
        pageName="Programa de Indicações"
        breadcrumbs={breadcrumbs}
        structuredData={{
          "@type": "Service",
          name: "Programa de Indicações metrocalma",
          description: "Indique amigos para a plataforma metrocalma e ganhe benefícios exclusivos."
        }}
      />
      
      <div className="container mx-auto p-6 max-w-2xl">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">Indique e Ganhe</h1>
          <SeshBalance variant="default" animated className="ml-2" />
        </div>
        
        <p className="text-sm text-gray-500 mb-8">
          Convide seus amigos para o metrocalma e ganhe Seshs para usar na plataforma
        </p>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <div className="mb-6">
            <ReferralTab />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Referrals;
